import { type FC } from 'react';
import { Link } from 'react-router-dom';

import { type Chapter } from '@editor2/types/chapter';
import { type PageGroup } from '@editor2/types/pageGroup';
import { type Page } from '@editor2/types/page';
import { type Course } from '@editor2/types/course';
import { breadcrumbItem } from './styles';

interface Props {
	course: Course;
	chapter?: Chapter;
	pageGroup?: PageGroup;
	page?: Page;
}

const BreadcrumbItem: FC<Props> = (props) => {
	const { course, chapter, pageGroup, page } = props;

	const getLink = () => {
		return (
			`/courses/${course.id}` +
			(chapter ? `/chapters/${chapter.family_id}` : '') +
			(pageGroup ? `/page_groups/${pageGroup.family_id}` : '') +
			(page ? `/pages/${page.family_id}` : '')
		);
	};

	const getLinkName = () => {
		return (page || pageGroup || chapter || course).name;
	};

	return (
		<div className={breadcrumbItem}>
			<Link to={getLink()}>{getLinkName()}</Link>
		</div>
	);
};

export default BreadcrumbItem;
